import { EnvironmentProviders, importProvidersFrom } from '@angular/core';

import { LucideAngularModule } from 'lucide-angular';
import {
  ProductIcons,
  SupplierIcons,
  CoreIcons,
  CustomerIcons,
  SaleIcons,
  FinancialIcons,
  PurchaseIcons,
  NavigationIcons,
  CashierIcons
} from '../icons';

export const AllIcons = {
  ...CustomerIcons,
  ...CoreIcons,
  ...SupplierIcons,
  ...ProductIcons,
  ...SaleIcons,
  ...FinancialIcons,
  ...PurchaseIcons,
  ...NavigationIcons,
  ...CashierIcons
};

export const provideIcons = (): EnvironmentProviders =>
  importProvidersFrom(LucideAngularModule.pick(AllIcons));
